import { Textbaustein, Vorlage, VorlageItem } from '@/models/VorlageModels';
import { PagedResult } from '@/models/CommonModels';

export type State = {
  vorlagen: Array<Vorlage>;
  textbausteine: Array<Textbaustein>;
  vorlageItems: Array<VorlageItem>;
  vorlagePage: PagedResult<VorlageItem>;
};

export const state: State = {
  vorlagen:
    localStorage.getItem('vorlagen') != null && localStorage.getItem('vorlagen') !== undefined ? JSON.parse(localStorage.vorlagen) : new Array<Vorlage>(),
  vorlageItems:
    localStorage.getItem('vorlageItems') != null && localStorage.getItem('vorlageItems') !== undefined
      ? JSON.parse(localStorage.vorlageItems)
      : new Array<VorlageItem>(),
  vorlagePage: {
    items: new Array<VorlageItem>(),
    pageIndex: 1,
    pageSize: 25,
    totalCount: 0,
    totalPages: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  },
  textbausteine:
    localStorage.getItem('textbausteine') != null && localStorage.getItem('textbausteine') !== undefined
      ? JSON.parse(localStorage.textbausteine)
      : new Array<Textbaustein>(),
};
